import React, { Component } from 'react';
import {
  Form,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { fetchM } from '../../actions/fetchM';
import Input from './Input';
import Helper from './Helper';
import Validate from './Validate';
import Select from './Select';

export default class AppForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node,
    error: PropTypes.bool,
    id: PropTypes.string,
    as: PropTypes.string,
    className: PropTypes.string,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static validate = (objRefs, values) => {
    // objRefs should be an object with refs
    const validations = [];
    Object.keys(objRefs).forEach((key) => {
      const ref = objRefs[key];
      // ref should be Validate component
      if (!ref || (ref && !ref.current)) {
        return;
      }

      // access `validate` function from Validate component
      let { validate } = ref.current;
      const { validateRef } = ref.current;
      if (validateRef && validateRef.current) {
        validate = validateRef.current.validate;
      }
      if (validate) {
        validations.push(validate(values[key]));
      }
    });
    return Promise.all(validations);
  }

  static Input = Input
  static Helper = Helper
  static Validate = Validate
  static Select = Select

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  });

  submit(url, opts = {}) {
    const { store } = this.context;
    return this.setLoading(true)
      .then(() => store.dispatch(fetchM(url, opts)))
      .then(res => res.json())
      .then(result => this.setLoading(false)
        .then(() => result))
      .catch(err => this.setLoading(false)
        .then(() => Promise.reject(err)));
  }

  handleSubmit = (event) => {
    this.props.onSubmit(event);
  }

  render() {
    return (
      <Form
        as={this.props.as}
        className={this.props.className}
        onSubmit={this.handleSubmit}
        error={this.props.error}
        loading={this.state.loading}
        id={this.props.id}
      >
        {this.props.children}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AppForm/AppForm.jsx